"use strict"

import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import {
  cleanObservationAxisAssignment,
  newPlotTrendsUpdate,
  getMatchingTrend,
  getUniqueTags,
} from "../../resources/utils"
import ObservationSelectorPopper from "../widgets/ObservationSelectorPopper"
import AxesAssignmentModal from "../../modals/AxesAssignmentModal"
import { deepcopy } from "../../../utils"

import { isLTPM, makePlotList } from "../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  select_btn_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.select" }) : "Select"),
  select_tags_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.select.tags.to.compare" }) : "Select Tags to Compare",
  default_plot_title: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.multiple.tag.overlay" }) : "Multiple Tag Overlay",
}

export default function ObsMultiTagKey({
  trendEditKey = "observations",
  graphKey = {},
  siteReactors = [],
  plotConfigUpdater,
  queryTags,
  observationTypesArray,
  availableOnly,
  intl,
}) {
  const [showAxesAssignModal, setShowAxesAssignModal] = useState(false)
  const [newGraph, setNewGraph] = useState([])
  const [plotList, setPlotList] = useState([])

  useEffect(() => {
    const observations = graphKey[trendEditKey] || []
    setPlotList(
      makePlotList([], queryTags, [], observationTypesArray)
        .map((plot) => {
          const obv = plot?.observations[0] || {}
          if (observations.find((o) => getMatchingTrend(o, obv, true))) {
            // Filter out trends already on plot
            return {
              ...plot,
              notAvailable: true,
            }
          } else {
            return plot
          }
        })
        .filter((p) => (availableOnly ? !p.notAvailable : p)),
    )
  }, [graphKey, observationTypesArray])

  const updatePlotTrends = (selections, op) => {
    // Get recommended axes assignments (observations)
    // deepcopy() is needed here to disassociate op we want to update from the passed op
    let [observations, plot, updated] = newPlotTrendsUpdate(deepcopy(op), selections, trendEditKey)
    // Clean tag assignments and labels
    plot = cleanObservationAxisAssignment(observations, plot, trendEditKey)
    // Adjust plot title
    if (getUniqueTags(op, trendEditKey).length === 1) {
      // Previous plot was single tag, shifting to more than 1 here
      plot.title = registration.default_plot_title(intl)
    }
    if (updated) {
      setShowAxesAssignModal(true)
      setNewGraph(plot)
    }
  }

  const updatePlot = (op) => {
    plotConfigUpdater(op)
  }

  return (
    <>
      {showAxesAssignModal && (
        <AxesAssignmentModal
          show={showAxesAssignModal}
          onHide={() => setShowAxesAssignModal(false)}
          intl={intl}
          disable_title_edit={false}
          newGraphKey={newGraph}
          graphKey={graphKey}
          onSubmit={(op) => {
            setShowAxesAssignModal(false)
            updatePlot(op)
          }}
        />
      )}
      <label>{registration.select_tags_label(intl)}:</label>&nbsp;
      <ObservationSelectorPopper
        placement={"bottom"}
        onMultiTagSubmit={(selections) => updatePlotTrends(selections, graphKey)}
        options={plotList}
        nameFn={(plot) => plot.title}
        onSelect={(sel) => updatePlotTrends([sel], graphKey)}
        runFilters={siteReactors}
      >
        <Button variant={"outline-primary"} className={"btn btn-sm"} disabled={plotList.length === 0}>
          {registration.select_btn_label(intl)}
        </Button>
      </ObservationSelectorPopper>
      <hr style={{ margin: "3px" }} />
    </>
  )
}
